import { trackLead } from "@/lib/analytics";

const PHONE = "918530635656";
const TEXT = "Hi, I want to schedule the Counselling session.";

// Authentic WhatsApp glyph (saves an icon import).
function WhatsAppGlyph({ size = 26 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width={size}
      height={size}
      fill="white"
      aria-hidden
    >
      <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977.96 2.834 1.205 2.092 2.694 3.969 4.844 5.094 1.02.575 2.13.946 3.244 1.106.273.043.56.057.846.057.547 0 1.107-.072 1.523-.317.522-.305.892-.91 1.022-1.5.072-.366.115-.91.115-1.16 0-.123-.115-.243-.215-.286-.346-.16-2.495-1.236-2.81-1.336zm.087-13.98C12.255 3.225 6.32 9.16 6.32 16.5c0 1.715.36 3.43 1.06 5l-1.39 4.987 5.13-1.378c1.49.673 3.13 1.029 4.787 1.029 7.4 0 13.34-5.99 13.34-13.275 0-7.218-6.001-13.638-13.34-13.638zm0 24.49c-1.55 0-3.058-.41-4.41-1.179l-.32-.187-3.273.86.875-3.157-.215-.34c-.831-1.328-1.27-2.857-1.27-4.426 0-4.591 4.025-8.58 8.93-8.58 5.092 0 8.93 4.066 8.93 8.58 0 4.514-3.838 8.43-9.247 8.43z"/>
    </svg>
  );
}

export default function WhatsAppFab() {
  const href = `https://wa.me/${PHONE}?text=${encodeURIComponent(TEXT)}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      onClick={() => trackLead({ method: "whatsapp", location: "fab" })}
      aria-label="Chat on WhatsApp"
      data-testid="whatsapp-fab-btn"
      className="fixed bottom-6 left-6 z-[55] w-14 h-14 rounded-full bg-[#25D366] border-2 border-[#282829] grid place-items-center brutal-shadow-ink hover:translate-y-[-2px] hover:bg-[#1ebd5b] transition-all"
    >
      <span className="absolute inset-0 rounded-full animate-ping bg-[#25D366] opacity-40 pointer-events-none" />
      <span className="relative">
        <WhatsAppGlyph size={26} />
      </span>
      <span className="sr-only">Chat on WhatsApp</span>
    </a>
  );
}
